import { voiceItems } from "@/mocks/gua";

export default function Voices() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6">
          <h3 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-chat-quote-line" />
            </span>
            网友讨论精华
          </h3>
          <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">
            从热评里挑几条不同视角的声音，方便你快速判断舆论的分歧在哪。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {voiceItems.map((v) => (
            <div key={v.id} className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-3">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">
                  {v.name.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-foreground-900">{v.name}</p>
                  <p className="truncate text-xs text-foreground-500">{v.handle}</p>
                </div>
                <span className="ml-auto shrink-0 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                  {v.tone}
                </span>
              </div>
              <p className="mt-3 flex-1 text-sm leading-6 text-foreground-700">“{v.text}”</p>
              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-600">
                <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap hover:text-accent-700">
                  <i className="ri-thumb-up-line" /> 认同 {v.agree}
                </a>
                <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap hover:text-primary-600">
                  <i className="ri-corner-down-right-line" /> 跟评
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}